import React from "react";
import { CustomColorBar } from "./ColorBarComponent";
import { COLORBAR_GRADIENT } from "./colorbarConstants";
import { useSensorPlacementColorBar } from "../CustomHooks";

const SensorPlacementColorBar = () => {
  const { isVisible } = useSensorPlacementColorBar();

  return (
    <CustomColorBar
      gradient={COLORBAR_GRADIENT.SENSOR_PLACEMENT}
      category="Sensor Placement"
      subcategory="Zone"
      unit="Score"
      dataMin={0}
      dataMax={1}
      isVisible={isVisible}
    />
  );
};

export default SensorPlacementColorBar;
